import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { CreateEventDTO, EventsApiService } from 'features/events';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { createEmailContent } = EventsApiService();

export const useCreateEmailContent = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: CreateEventDTO) => {
            return createEmailContent(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                message.success('Email Content has been created successfully!!');
            },
        },
    );
};
